import {Component} from '@angular/core';

@Component({
    selector: 'tfl-undelivered-transfer-icon',
    template: require('./undelivered.html')
})
export class UndeliveredTransferIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/undelivered/undelivered.transfer.icon.ts